import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Grid } from '@material-ui/core';

import { getErrorData } from 'common/constants/get-error-data';
import { DialogBodyPropTypes } from './prop-types';

import styles from './error-dialog.styles';

const isJsonString = (str) => {
  try {
    return typeof str === 'object' && JSON.parse(str);
  } catch (e) {
    return false;
  }
};

const DialogBody = ({ title, errors, onClick, label, classes, showGoHomeButton = true }) => {
  return (
    <div className={classes.body}>
      <div>
        <span className={classes.title}>{title || 'Power outage!'}</span>
        {errors &&
          errors.map((message) => {
            // Only use getErrorData if we're confident this is an actual error code
            const errorCode = parseInt(message, 10);
            const errorData = errorCode ? getErrorData({ error: { code: errorCode }, errorType: 'REJECTION' }) : null;
            message = (errorData?.policyErrorMessage || errorData?.why) ?? message;

            return (
              <span key={message} className={classes.message}>
                {isJsonString(message) ? JSON.parse(message) : message}
              </span>
            );
          })}
      </div>
      <Grid container justifyContent="flex-end" spacing={4}>
        {showGoHomeButton && (
          <Grid item xs={6}>
            <Button
              onClick={() => {
                window.location.href = '/';
              }}
              className={classes.button}
              variant="contained"
              color="secondary"
            >
              Go to home
            </Button>
          </Grid>
        )}
        {label && onClick && (
          <Grid item xs={6}>
            <Button onClick={onClick} className={classes.button} variant="contained" color="primary">
              {label}
            </Button>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

DialogBody.propTypes = DialogBodyPropTypes;

export default withStyles(styles)(DialogBody);
